export default __webpack_public_path__ + "static/media/Switch-1.7082d6e9.jpg";